import { useFrontofficeContext } from "../../../../context/FrontofficeContext";
import { useLanguageContext } from "../../../../context/LanguageContext";
import PrintLabel from "../../../../pages/printers/printer/label_editor/label/PrintLabel";

function PrintStepView({ controller }) {
  const { terminal } = useFrontofficeContext();
  const { translate } = useLanguageContext();

  return (
    <>
      <p>
        {translate("eva.frontoffice.pages.visitor_type.steps.print.loading")}
      </p>

      {terminal?.printer && (
        <PrintLabel
          printerData={terminal.printer}
          visitorData={{
            ...controller.visitorData,
            ...controller.visitor,
          }}
          readOnly={true}
        />
      )}
    </>
  );
}

export default PrintStepView;
